import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "page-apps custom-scroll"
};
const _hoisted_2 = {
  class: "flex pt-[30px]"
};
const _hoisted_3 = {
  class: "org-scrollbar-type-nav"
};
const _hoisted_4 = {
  class: "image"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "image"
};
const _hoisted_7 = {
  class: "item"
};
const _hoisted_8 = {
  class: "image"
};
const _hoisted_9 = {
  class: "inner"
};
const _hoisted_10 = {
  class: "info"
};
const _hoisted_11 = {
  class: "info-title"
};
const _hoisted_12 = {
  class: "info-text"
};
const _hoisted_13 = {
  class: "btn"
};
const _hoisted_14 = {
  key: 1,
  style: {
    "width": "100%"
  }
};
import nodata from "@/assets/img/no-data.png";
import { CreditCard } from "@element-plus/icons-vue";
import { onMounted, ref } from "vue";
import { ElMessage } from "element-plus";
import { httpGet, httpPost } from "@/utils/http";
import { checkSession } from "@/store/cache";
import { arrayContains, removeArrayItem, substr } from "@/utils/libs";
import { useRouter } from "vue-router";
import { useSharedStore } from "@/store/sharedata";
import ItemList from "@/components/ItemList.vue";
import { ChatConversationApi } from "@/api/ai/chat/conversation";
export default /*@__PURE__*/_defineComponent({
  __name: 'OrgChatApps',
  setup(__props) {
    const listBoxHeight = window.innerHeight - 133;
    const typeId = ref("");
    const appTypes = ref([]);
    const list = ref([]);
    const roles = ref([]);
    const store = useSharedStore();
    onMounted(() => {
      getAppType();
      getAppList();
      getRoles();
    });
    const getRoles = () => {
      checkSession().then(user => {
        roles.value = user.chat_roles;
      }).catch(e => {
        console.log(e.message);
      });
    };
    const getAppType = () => {
      // httpGet("/app/type/list")
      httpGet("/ai/chat-role/type/list").then(res => {
        appTypes.value = res;
      }).catch(e => {
        ElMessage.error("获取分类失败：" + e.message);
      });
    };
    const getAppList = (tid = "") => {
      typeId.value = tid;
      // httpGet("/app/list", { tid })
      httpGet("/ai/chat-role/list", {
        tid
      }).then(res => {
        const items = res;
        // 处理 hello message
        for (let i = 0; i < items.length; i++) {
          items[i].intro = substr(items[i].hello_msg, 80);
        }
        list.value = items;
      }).catch(e => {
        ElMessage.error("获取应用失败：" + e.message);
      });
    };
    const updateRole = (row, opt) => {
      checkSession().then(() => {
        const title = ref("");
        if (opt === "add") {
          title.value = "添加应用";
          const exists = arrayContains(roles.value, row.key);
          if (exists) {
            return;
          }
          roles.value.push(row.key);
        } else {
          title.value = "移除应用";
          const exists = arrayContains(roles.value, row.key);
          if (!exists) {
            return;
          }
          roles.value = removeArrayItem(roles.value, row.key);
        }
        httpPost("/app/update", {
          keys: roles.value
        }).then(() => {
          ElMessage.success({
            message: title.value + "成功！",
            duration: 1000
          });
        }).catch(e => {
          ElMessage.error(title.value + "失败：" + e.message);
        });
      }).catch(() => {
        store.setShowLoginDialog(true);
      });
    };
    const hasRole = roleKey => {
      return arrayContains(roles.value, roleKey, (v1, v2) => v1 === v2);
    };
    const router = useRouter();
    const useRole = async role => {
      // 1. 创建对话
      const data = {
        roleId: role.id
      };
      const conversationId = await ChatConversationApi.createChatConversationMy(data);
      // 2. 跳转页面
      await router.push({
        name: 'AiChat1',
        query: {
          conversationId: conversationId
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_empty = _resolveComponent("el-empty");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ul", _hoisted_3, [_createElementVNode("li", {
        class: _normalizeClass({
          active: typeId.value === ''
        }),
        onClick: _cache[0] || (_cache[0] = $event => getAppList(''))
      }, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(CreditCard))]),
        _: 1
      })]), _cache[1] || (_cache[1] = _createTextVNode("全部分类 "))], 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appTypes.value, item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.id,
          class: _normalizeClass({
            active: typeId.value === item.id
          }),
          onClick: $event => getAppList(item.id)
        }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(CreditCard))]),
          _: 1
        })]), _createTextVNode(" " + _toDisplayString(item.name), 1)], 10, _hoisted_5);
      }), 128))])]), _createVNode(_component_el_divider), _createElementVNode("div", {
        class: "app-list-container",
        style: _normalizeStyle({
          height: listBoxHeight + 'px'
        })
      }, [list.value.length > 0 ? (_openBlock(), _createBlock(ItemList, {
        key: 0,
        items: list.value,
        "show-option": false,
        gap: 15,
        width: 300
      }, {
        default: _withCtx(scope => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_image, {
          src: scope.item.icon,
          fit: "cover"
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(scope.item.name), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(scope.item.hello_msg), 1)]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
          size: "small",
          class: "sm-btn-theme",
          onClick: $event => useRole(scope.item)
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("使用")])),
          _: 2
        }, 1032, ["onClick"])])])])]),
        _: 1
      }, 8, ["items"])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_el_empty, {
        description: "暂无数据",
        image: _unref(nodata)
      }, null, 8, ["image"])]))], 4)])]);
    };
  }
});